module.exports = __webpack_public_path__ + "public/images/Illustration_Puzzle_200x200-Color.b3f91e095299edf95c5af56753e1859b.png";